(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/active-exclusions.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/active-exclusions.js');
'use strict';

const {
  Constants
} = svs.selfExclusion;
const {
  ExclusionView,
  NanExcluded,
  NeedsUnlock
} = svs.selfExclusion.components;
const ActiveExclusions = _ref => {
  let {
    exclusions,
    naExcluded
  } = _ref;
  const needsUnlock = svs.selfExclusion.useNeedsUnlock(exclusions);
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2"
  }, naExcluded && React.createElement("div", {
    className: "exclusion-pause-wrapper"
  }, React.createElement(NanExcluded, {
    exclusions: exclusions,
    url: Constants.URL.EXCLUSION
  })), !naExcluded && exclusions && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2"
  }, React.createElement(ExclusionView, {
    exclusions: exclusions
  })), needsUnlock && React.createElement("div", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-top-2"
  }, React.createElement(NeedsUnlock, {
    phone: Constants.PHONE
  })))), React.createElement("hr", {
    "aria-hidden": true,
    className: "exclusion-border-bottom"
  }));
};
svs.selfExclusion.components.ActiveExclusions = ActiveExclusions;

 })(window);